var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87 256H512C512 232.893 508.92 210.511 503.181 189.217H244.87V256Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87 122.435H474.426C458.755 96.8629 438.72 74.2599 415.357 55.6519H244.87V122.435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512C316.249 512 371.626 491.176 415.357 456.348H96.6429C140.374 491.176 195.751 512 256 512V512Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.574 389.565H474.426C487.007 369.037 496.763 346.596 503.181 322.782H8.81897C15.236 346.596 24.993 369.037 37.574 389.565V389.565Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 256C256 114.616 256 97.948 256 0C114.616 0 0 114.616 0 256H256Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.234 219.13C135.272 219.13 106.93 190.787 106.93 155.826C106.93 120.865 135.273 92.5221 170.234 92.5221C181.135 92.5221 191.392 95.2791 200.347 100.131C186.299 86.3941 167.087 77.9141 145.886 77.9141C102.857 77.9141 67.973 112.797 67.973 155.827C67.973 198.857 102.857 233.74 145.886 233.74C167.087 233.74 186.299 225.26 200.347 211.523C191.392 216.373 181.136 219.13 170.234 219.13V219.13Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.073 111.304L199.312 134.806L224.693 128.942L213.327 152.381L233.739 168.568L208.325 174.297L208.396 200.348L188.073 184.05L167.749 200.348L167.819 174.297L142.405 168.568L162.817 152.381L151.45 128.942L176.833 134.806L188.073 111.304Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.31cb046b4a96592a2b4b1b4af38b71f4.svg";
export { ForwardRef as ReactComponent };